import { get, post } from '../utils/request';

// 保存服务
export const saveServiceProduct = (params:any) => {
  return post<any>('product/save_service_product',params);
};
// 获取服务
export const getServiceProduct = (params:any) => {
  return get<any>('product/get_service_product_page_list',params);
};
// 详情服务
// product/get_service_product
export const getServiceProductDetail = (params:any) => {
  return get<any>('product/get_service_product',params);
};
// 修改服务
export const updateServiceProduct = (params:any) => {
  return post<any>('product/update_service_product',params);
};
// 删除服务
export const deleteService = (params:any) => {
  return post<any>('product/save_service_product_delete',params);
};
export const getServiceProductPageListByKeyword = (params: any) => {
  return get<any>('product/get_service_product_page_list_by_keyword', params);
};


// 获取服务不需要登录的接口
export const getWebServiceProduct = (params:any) => {
  return get<any>('/web/get_service_product_page_list',params);
};



// 普通服务详情不需要登录的接口
// product/get_service_product
export const getServiceWebProductDetail = (params:any) => {
  return get<any>('web/get_service_product_detail_by_service_id',params);
};